import { config } from 'app/config';
import { Promo, Content, Version, Links } from './footer.styled';

export const Footer = () => {
  if (config.template) {
    return null;
  }
  const promo = config.promo;
  return (
    <Content>
      <Version>{config.version}</Version>
      {config.showDocs && (
        <Links>
          <a title="Инструкция" href="/docs/qr.pdf" target="_blank" rel="noopener">
            Инструкция
          </a>
          <a title="Оферта" href="/docs/offer_services.pdf" target="_blank" rel="noopener">
            Оферта
          </a>
        </Links>
      )}
      {promo && (
        <Promo>
          <a href={promo.link} target="_blank" rel="noopener">
            <img src={'/docs/' + promo.img} alt="" />
          </a>
        </Promo>
      )}
    </Content>
  );
};
